import React from 'react';

const PILL = {
  W: { bg: '#00a839', label: 'W' },
  D: { bg: '#d48e00', label: 'D' },
  L: { bg: '#e40000', label: 'L' },
};

/** Last N results as green / amber / red pills (W D L). */
export default function FormPills({ form = '', max = 5, size = 18 }) {
  const chars = String(form || '')
    .toUpperCase()
    .replace(/[^WDL]/g, '')
    .slice(-max)
    .split('');

  if (!chars.length) {
    return <span style={{ color: 'var(--sw-muted)', fontSize: 10 }}>—</span>;
  }

  return (
    <span className="inline-flex items-center gap-0.5 justify-end" role="img" aria-label={`Form ${form}`}>
      {chars.map((ch, i) => {
        const pill = PILL[ch];
        if (!pill) return null;
        return (
          <span
            key={`${ch}-${i}`}
            className="inline-flex items-center justify-center font-bold text-white rounded-sm"
            style={{
              width: size,
              height: size,
              fontSize: size * 0.45,
              backgroundColor: pill.bg,
              lineHeight: 1,
            }}
            title={ch === 'W' ? 'Win' : ch === 'D' ? 'Draw' : 'Loss'}
          >
            {pill.label}
          </span>
        );
      })}
    </span>
  );
}
